import { Minus, Plus } from 'lucide-react';

interface QuantitySelectorProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
}

export default function QuantitySelector({
  value,
  onChange,
  min = 1,
  max = 99,
}: QuantitySelectorProps) {
  const decrease = () => {
    if (value > min) onChange(value - 1);
  };
  const increase = () => {
    if (value < max) onChange(value + 1);
  };

  return (
    <div className="inline-flex items-center gap-2">
      <button
        type="button"
        onClick={decrease}
        disabled={value <= min}
        className="flex items-center justify-center w-8 h-8 rounded-full border border-coffee-300 text-coffee-700 hover:bg-coffee-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        aria-label="Disminuir cantidad"
      >
        <Minus className="w-4 h-4" />
      </button>
      <span className="min-w-[2rem] text-center font-semibold text-coffee-900 select-none">
        {value}
      </span>
      <button
        type="button"
        onClick={increase}
        disabled={value >= max}
        className="flex items-center justify-center w-8 h-8 rounded-full border border-coffee-300 text-coffee-700 hover:bg-coffee-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        aria-label="Aumentar cantidad"
      >
        <Plus className="w-4 h-4" />
      </button>
    </div>
  );
}
